var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState, } from "react";
import hash from "object-hash";
import { TabsContainer } from "./TabsContainer.styles";
import { Tab } from "../Tab";
import { TabsWrapper } from "./Tabs.styles";
export const Tabs = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { items, alignment = "horizontal", onTabChange, initialSelected = 0, stylingType, tabPanelPosition = "top", maxWidth, changeOnMouseOver, removeSelectedTabIndex, previewId, previewIdExtractor, usedForNavigation = false, dataTestIdPrefix, titleTag, } = props;
    const [selectedTabIndex, setSelectedTabIndex] = useState(changeOnMouseOver || removeSelectedTabIndex
        ? undefined
        : initialSelected !== -1
            ? initialSelected
            : items === null || items === void 0 ? void 0 : items.findIndex((item) => item.isActive));
    useEffect(() => {
        if (removeSelectedTabIndex)
            setSelectedTabIndex(undefined);
    }, [removeSelectedTabIndex]);
    useEffect(() => {
        setSelectedTabIndex(initialSelected);
    }, [initialSelected]);
    function handleOnTabChange(selectedTab) {
        if (onTabChange) {
            onTabChange(selectedTab);
        }
        if (!usedForNavigation) {
            setSelectedTabIndex(selectedTab.index);
        }
    }
    function getChildren(withTitle = false) {
        return React.Children.toArray(children)
            .filter((child) => {
            return !!child.props.title === withTitle;
        })
            .slice();
    }
    const tabs = useMemo(() => {
        if (items) {
            return items.map((item, index) => (_jsx(Tab, { "data-preview-id": typeof previewIdExtractor === "function"
                    ? previewIdExtractor(item, index)
                    : undefined, index: index, title: item.title, titleTag: titleTag, subTitle: item.subTitle, alignment: alignment, symbol: item.symbol, statusLeft: item.renderStatusLeft ? item.renderStatusLeft(item) : null, statusRight: item.renderStatusRight ? item.renderStatusRight(item) : null, stylingType: stylingType, selected: index === selectedTabIndex, disabled: item.disabled, onTabChange: handleOnTabChange, changeOnMouseOver: changeOnMouseOver, isActive: item.isActive, withoutIcon: item.withoutIcon ? item.withoutIcon : false, onClick: item.onClick, dataTestIdPrefix: dataTestIdPrefix }, hash({ item, index }))));
        }
        return getChildren(true).map((item, index) => React.isValidElement(item) ? (React.cloneElement(item, Object.assign(Object.assign({}, props), { index,
            alignment, stylingType: alignment === "vertical" ? stylingType : undefined, selected: index === selectedTabIndex, statusLeft: item.props.renderStatusLeft
                ? item.props.renderStatusLeft(item)
                : null, statusRight: item.props.renderStatusRight
                ? item.props.renderStatusRight(item)
                : null, onTabChange: handleOnTabChange, key: hash({ item: item.props, index }), "data-preview-id": typeof previewIdExtractor === "function"
                ? previewIdExtractor(item, index)
                : undefined }))) : (_jsx(React.Fragment, {}, hash(Math.random))));
    }, [items, selectedTabIndex]);
    function renderTabPanel() {
        var _a;
        const TabPanelItem = getChildren().pop();
        if (!React.isValidElement(TabPanelItem)) {
            return null;
        }
        const tabPanel = (_a = TabPanelItem.props.children) === null || _a === void 0 ? void 0 : _a[selectedTabIndex];
        if (!tabPanel || !React.isValidElement(tabPanel)) {
            return null;
        }
        return tabPanel;
    }
    const tabPanel = renderTabPanel();
    return (_jsxs(TabsWrapper, Object.assign({ maxWidth: maxWidth, tabPanelPosition: tabPanelPosition }, { children: [_jsx(TabsContainer, Object.assign({ "data-preview-id": previewId, withTabPanel: !!tabPanel, alignment: alignment, className: "TabList" }, { children: tabs })), _jsx("div", Object.assign({ className: "TabPanelContainer" }, { children: tabPanel }))] })));
};
